(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8082,9534],{

/***/ 93445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand",
      function () {
        return __webpack_require__(61903);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADDTHIS_ID": function() { return /* binding */ ADDTHIS_ID; },
/* harmony export */   "BOPUS_SHIPPING_DESCRIPTION": function() { return /* binding */ BOPUS_SHIPPING_DESCRIPTION; },
/* harmony export */   "BRAND": function() { return /* binding */ BRAND; },
/* harmony export */   "EXTEND_LOGO": function() { return /* binding */ EXTEND_LOGO; },
/* harmony export */   "EXTEND_SKU": function() { return /* binding */ EXTEND_SKU; },
/* harmony export */   "FOOTER_SECTIONS": function() { return /* binding */ FOOTER_SECTIONS; },
/* harmony export */   "FREE_SHIPPING_AMOUNT": function() { return /* binding */ FREE_SHIPPING_AMOUNT; },
/* harmony export */   "FREE_SHIPPING_DESCRIPTION": function() { return /* binding */ FREE_SHIPPING_DESCRIPTION; },
/* harmony export */   "GIFT_BOX_SKU": function() { return /* binding */ GIFT_BOX_SKU; },
/* harmony export */   "PARKY_CREDIT_CARD_TRANSACTION_METHOD": function() { return /* binding */ PARKY_CREDIT_CARD_TRANSACTION_METHOD; },
/* harmony export */   "PARKY_PAYPAL_TRANSACTION_METHOD": function() { return /* binding */ PARKY_PAYPAL_TRANSACTION_METHOD; },
/* harmony export */   "PLP_Items_Per_Page": function() { return /* binding */ PLP_Items_Per_Page; },
/* harmony export */   "SHIPPED_SHIELD_LOGO": function() { return /* binding */ SHIPPED_SHIELD_LOGO; },
/* harmony export */   "SHIPPED_SHIELD_SKU": function() { return /* binding */ SHIPPED_SHIELD_SKU; },
/* harmony export */   "STANDARD_PLUS_SHIPPING_DESCRIPTION": function() { return /* binding */ STANDARD_PLUS_SHIPPING_DESCRIPTION; },
/* harmony export */   "STANDARD_SHIPPING_DESCRIPTION": function() { return /* binding */ STANDARD_SHIPPING_DESCRIPTION; },
/* harmony export */   "STORE_MAIN_LOGO_URL": function() { return /* binding */ STORE_MAIN_LOGO_URL; },
/* harmony export */   "STORE_MINI_LOGO_URL": function() { return /* binding */ STORE_MINI_LOGO_URL; },
/* harmony export */   "STORE_PHONE": function() { return /* binding */ STORE_PHONE; },
/* harmony export */   "designSkus": function() { return /* binding */ designSkus; },
/* harmony export */   "storeOperationHours": function() { return /* binding */ storeOperationHours; }
/* harmony export */ });
var STORE_PHONE = "(332) 333-6412";
var GIFT_BOX_SKU = "990000007";
var ADDTHIS_ID = "ra-5f4ec39268f6acd2";
var FREE_SHIPPING_AMOUNT = 49.00;
var EXTEND_SKU = ";xtd;";
var SHIPPED_SHIELD_SKU = "SHIPPED_ASSURANCE_";
var BOPUS_SHIPPING_DESCRIPTION = "Zgallerie (BOPS)";
var FREE_SHIPPING_DESCRIPTION = "Free Shipping";
var STANDARD_SHIPPING_DESCRIPTION = "Zgallerie (Standard)";
var STANDARD_PLUS_SHIPPING_DESCRIPTION = "Zgallerie (Standard Plus)";
var STORE_MAIN_LOGO_URL = "https://assets.onekingslane.com/m/2a3672007ee7fa59/original/OKL-logo-reg.png";
var STORE_MINI_LOGO_URL = "data:image/png;base64,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";
var PARKY_CREDIT_CARD_TRANSACTION_METHOD = "Credit Card";
var PARKY_PAYPAL_TRANSACTION_METHOD = "PayPal";
var EXTEND_LOGO = "https://cdn11.bigcommerce.com/s-whvhnri10h/product_images/uploaded_images/extend-logo.png";
var SHIPPED_SHIELD_LOGO = "https://cdn11.bigcommerce.com/s-ccb3mj27tc/products/1821415/images/817186/shield-be9ba978feb179704666141db2d825d1f9d9cc55787fdcbf9885dff04b0dd644__12393.1680276093.220.290.png";
var BRAND = "One Kings Lane";
var PLP_Items_Per_Page = 60;
var FOOTER_SECTIONS = [
    {
        heading: "Our Company",
        links: [
            {
                name: "About Us",
                href: "/about-us"
            },
            {
                name: "Careers",
                href: "/careers"
            },
            {
                name: "Blog",
                href: "https://blog.onekingslane.com/"
            }
        ]
    },
    {
        heading: "Customer Care",
        links: [
            {
                name: "Returns",
                href: "https://returns.narvar.com/okl/returns"
            },
            {
                name: "Order Status",
                href: "/order-status"
            },
            {
                name: "FAQ",
                href: "/faq",
                ariaLabel: "Frequently asked questions"
            },
            {
                name: "Return Policy",
                href: "/faq/#returns-exchange"
            },
            {
                name: "Shipping and Delivery",
                href: "/faq/#shipping-delivery",
                ariaLabel: "Frequently asked questions"
            },
            {
                name: "Request a Swatch",
                href: "/swatch-request"
            },
            {
                name: "Request a Catalog",
                href: "/request-a-catalog-faq"
            },
            {
                name: "Contact Us",
                href: "/contact-us"
            }, 
        ]
    },
    {
        heading: "Resources",
        links: [
            {
                name: "Free Design Services",
                href: "/design-services"
            },
            {
                name: "To the Trade",
                href: "/to-the-trade"
            },
            {
                name: "Affiliates",
                href: "/affiliates-apply-now"
            },
            {
                name: "Farrow & Ball",
                href: "/farrow-ball"
            },
            {
                name: "Protection Plan",
                href: "/extend-faq"
            },
            {
                name: "Citizens Pay\xae",
                href: "/citizens-pay-faq"
            },
            {
                name: "Extend",
                href: "/extend-faq"
            }, 
        ]
    }, 
];
var designSkus = [
    "77469310",
    "77496064",
    "77496065",
    "77496066",
    "77496067",
    "77496068",
    "77496069",
    "77496070",
    "77496203",
    "77534784",
    "77534785",
    "77534786",
    "77534787",
    "77534788",
    "77535257",
    "77535258",
    "77535259",
    "77542926",
    "77542927",
    "77542928",
    "77542929",
    "77542930",
    "77542931",
    "77542932",
    "77542933",
    "77542934",
    "77542935",
    "77542936",
    "77542937",
    "77542938",
    "77542939",
    "77542940",
    "77576646",
    "77576647",
    "77576648",
    "77576649",
    "77576650",
    "77576651", 
];
var storeOperationHours = [
    "Monday-Friday 9 am - 7 pm EST",
    "Weekends & Holidays Closed", 
];


/***/ }),

/***/ 28764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48080);






var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var usePLPAnalytics = function(param) {
    var cart = param.cart, customer = param.customer, products = param.products, categoryName = param.categoryName, _plpType = param.plpType, plpType = _plpType === void 0 ? "category" : _plpType;
    var PLPAnalytics = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, HeapAnalytics, getCustomerOrderCount, cartTotal, customerId, customerEmail, impressions, orderCount, sendToGA;
        return _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 4187).then(__webpack_require__.bind(__webpack_require__, 14187)),
                            __webpack_require__.e(/* import() */ 2054).then(__webpack_require__.bind(__webpack_require__, 32054)), 
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    HeapAnalytics = ref[0].HeapAnalytics;
                    getCustomerOrderCount = ref[1].getCustomerOrderCount;
                    cartTotal = (cart === null || cart === void 0 ? void 0 : cart.total.toFixed(2)) || 0;
                    customerId = (customer === null || customer === void 0 ? void 0 : customer.entityId) || 0;
                    customerEmail = (customer === null || customer === void 0 ? void 0 : customer.email) || "";
                    impressions = products.map(function(product, index) {
                        return {
                            name: product.name,
                            id: product.variants[0].sku,
                            price: product.calculated_price,
                            brand: product.brand,
                            category: categoryName,
                            variant: product.variants[0].id,
                            list: kebabCase(categoryName),
                            position: index + 1
                        };
                    });
                    _ctx.next = 14;
                    return getCustomerOrderCount(customerId, customerEmail);
                case 14:
                    orderCount = _ctx.sent;
                    sendToGA = function() {
                        var ref, ref1, ref2, ref3;
                        window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.push) === null || ref1 === void 0 ? void 0 : ref1.call(ref, {
                            event: "collectionView",
                            ecommerce: {
                                currencyCode: "USD",
                                impressions: impressions,
                                customerEmail: customerEmail,
                                customerId: customerId,
                                visitorType: customerId ? "Logged In" : "Guest"
                            },
                            customerEmail: customerEmail,
                            pageName: "plp"
                        });
                        window === null || window === void 0 ? void 0 : (ref2 = window.dataLayer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.push) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, {
                            event: "customer",
                            visitorType: customerId ? "Logged In" : "Guest",
                            customerId: customerId,
                            customerEmail: customerEmail,
                            customerOrdersCount: orderCount,
                            customerTotalSpent: "",
                            cartTotal: cartTotal,
                            pageType: plpType
                        });
                    };
                    if (window.loadedAndInteractive) {
                        sendToGA();
                    } else {
                        window.addEventListener("loadedAndInteractive", sendToGA, {
                            once: true
                        });
                    }
                    HeapAnalytics.identify({
                        visitorType: customerId ? "Logged In" : "Guest",
                        customerId: customerId,
                        customerEmail: customerEmail,
                        customerOrderCount: orderCount,
                        pageType: plpType
                    });
                    _ctx.next = 23;
                    break;
                case 20:
                    _ctx.prev = 20;
                    _ctx.t2 = _ctx["catch"](0);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("PLPAnalytics Error", _ctx.t2);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                20
            ]
        ]);
    })), [
        cart,
        customer,
        products,
        categoryName,
        plpType
    ]);
    return {
        PLPAnalytics: PLPAnalytics
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePLPAnalytics);


/***/ }),

/***/ 61903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84749);
/* harmony import */ var _hooks_usePLPAnalytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28764);
/* harmony import */ var _services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57927);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48080);














var Default = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(Promise.all(/* import() */[__webpack_require__.e(3480), __webpack_require__.e(1587)]).then(__webpack_require__.bind(__webpack_require__, 20882)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20882)
            ];
        }
    }
});
var PLP = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 6553).then(__webpack_require__.bind(__webpack_require__, 66553)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66553)
            ];
        }
    }
});
var BrandPage = function(param) {
    var content = param.content, breadcrumbs = param.breadcrumbs, category = param.category, total = param.total, legacyId = param.legacyId, slug = param.slug, query = param.query, facets = param.facets, products = param.products, currentPage = param.currentPage, sitewideBanner = param.sitewideBanner, megaNav = param.megaNav, itemsPerPage = param.itemsPerPage, sort = param.sort, userAgent = param.userAgent;
    var ref = (0,_services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_6__.useClientSideCartAndUser)(), cart = ref.cart, setCart = ref.setCart, user = ref.user;
    var categoryName = (category === null || category === void 0 ? void 0 : category.name) || "";
    var PLPAnalytics = (0,_hooks_usePLPAnalytics__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        plpType: "brand",
        cart: cart,
        customer: user,
        products: products,
        categoryName: categoryName
    }).PLPAnalytics;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        PLPAnalytics();
    }, [
        products,
        cart,
        PLPAnalytics
    ]);
    var metaTags = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var description = breadcrumbs.slice(0).reverse().map(function(param) {
            var name = param.name;
            return name;
        }).concat(_data_constants__WEBPACK_IMPORTED_MODULE_4__.BRAND).join(" | ");
        var title = "".concat(categoryName, " | Brands | One Kings Lane");
        return {
            description: description,
            title: title
        };
    }, [
        breadcrumbs,
        categoryName
    ]);
    var baseHref = "/brand?slug=".concat(slug, "&legacyId=").concat(legacyId, "&");
    var baseUrl =  true ? "".concat(window.location.pathname, "?") : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Default, {
        user: user,
        sitewideBanner: sitewideBanner,
        megaNav: megaNav,
        meta: metaTags,
        cart: cart,
        onUpdateCart: setCart,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PLP, {
            itemsPerPage: itemsPerPage,
            baseHref: baseHref,
            baseUrl: baseUrl,
            currentPage: currentPage,
            products: products,
            showBreadcrumbs: !(content === null || content === void 0 ? void 0 : content.hideBreadcrumbs),
            breadcrumbs: breadcrumbs,
            PLPHeader: categoryName,
            totalNumberOfProducts: total,
            facets: facets,
            queryParam: query,
            plpBanner: content,
            shouldUseMerchandising: currentPage === 1 && sort === "ourPicks",
            userAgent: userAgent,
            isCategoryEvent: true
        })
    });
};
var getQueryWithValidCharacters = function(queryWithoutSlug) {
    var LEGAL_FILTER_CHARACTER_SET = /^[\w \-+,%$'"&]+$/;
    var hasIllegalChar = function(str) {
        return !LEGAL_FILTER_CHARACTER_SET.test(str);
    };
    var deleteKey = function(key) {
        return delete queryWithoutSlug[key];
    };
    Object.keys(queryWithoutSlug).forEach(function(key) {
        var value = queryWithoutSlug[key];
        if (!value) {
            deleteKey(key);
        } else if (Array.isArray(value)) {
            deleteKey(key);
        } else if (hasIllegalChar(value)) {
            deleteKey(key);
        }
    });
    return queryWithoutSlug;
};
var _tmp;
_tmp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
        var ref, req, res, query, asPath, userAgent, legacyId, slug, queryWithoutSlug, legalQuery, path, currentPage, itemsPerPageFromQueryParam, itemsPerPage, ref1, Search, Content, getSiteWideInitialProps, getWindowAgent, ref2, siteWideInitialProps, response, content, category, facets, _products, products, breadcrumbs, total, ref3, SiteWideInitialPropsFailure;
        return _codebuild_output_src3449668696_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    req = ctx.req, res = ctx.res, query = ctx.query, asPath = ctx.asPath;
                    userAgent = "";
                    legacyId = Array.isArray(query === null || query === void 0 ? void 0 : query.legacyId) ? query === null || query === void 0 ? void 0 : (ref = query.legacyId) === null || ref === void 0 ? void 0 : ref[0] : (query === null || query === void 0 ? void 0 : query.legacyId) || "";
                    slug = query.slug, queryWithoutSlug = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(query, [
                        "slug"
                    ]);
                    legalQuery = getQueryWithValidCharacters(queryWithoutSlug);
                    path = "".concat(asPath || "").replace(/^(\/c-[a-z-]+)\//, "$1");
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_7__/* .log */ .cM)("Category Page getServerSideProps ".concat(JSON.stringify({
                        path: path,
                        asPath: asPath
                    })));
                    currentPage = parseInt("".concat(String((query === null || query === void 0 ? void 0 : query.page) || ""))) || 1;
                    _ctx.prev = 9;
                    itemsPerPageFromQueryParam = query.limit;
                    itemsPerPage = (typeof itemsPerPageFromQueryParam === "string" ? parseInt(itemsPerPageFromQueryParam) : 0) || _data_constants__WEBPACK_IMPORTED_MODULE_4__.PLP_Items_Per_Page;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
                    _ctx.next = 15;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.all(/* import() */[__webpack_require__.e(9638), __webpack_require__.e(5621)]).then(__webpack_require__.bind(__webpack_require__, 35621)),
                            __webpack_require__.e(/* import() */ 7465).then(__webpack_require__.bind(__webpack_require__, 27465)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57927)),
                            __webpack_require__.e(/* import() */ 2054).then(__webpack_require__.bind(__webpack_require__, 32054)), 
                        ];
                    });
                case 15:
                    _ctx.t1 = _ctx.sent;
                    ref1 = (0, _ctx.t0)(_ctx.t1, 4);
                    Search = ref1[0].Search;
                    Content = ref1[1].Content;
                    getSiteWideInitialProps = ref1[2].getSiteWideInitialProps;
                    getWindowAgent = ref1[3].getWindowAgent;
                    userAgent = getWindowAgent(req) || userAgent;
                    _ctx.t2 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
                    _ctx.t3 = Promise;
                    _ctx.t4 = getSiteWideInitialProps(ctx);
                    _ctx.t5 = Search.category({
                        path: path,
                        page: currentPage,
                        legacyId: legacyId,
                        limit: itemsPerPage
                    });
                    _ctx.next = 28;
                    return Content.categoryPage({
                        id: legacyId
                    });
                case 28:
                    _ctx.t6 = _ctx.sent;
                    _ctx.t7 = [
                        _ctx.t4,
                        _ctx.t5,
                        _ctx.t6, 
                    ];
                    _ctx.next = 32;
                    return _ctx.t3.all.call(_ctx.t3, _ctx.t7);
                case 32:
                    _ctx.t8 = _ctx.sent;
                    ref2 = (0, _ctx.t2)(_ctx.t8, 3);
                    siteWideInitialProps = ref2[0];
                    response = ref2[1];
                    content = ref2[2];
                    if (response) {
                        _ctx.next = 39;
                        break;
                    }
                    throw new Error("No response from search endpoint!");
                case 39:
                    category = response.category, facets = response.facets, _products = response.products, products = _products === void 0 ? [] : _products, breadcrumbs = response.breadcrumbs, total = response.total;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        legacyId: legacyId,
                        slug: slug,
                        content: content,
                        category: category,
                        query: legalQuery
                    }, siteWideInitialProps), {
                        products: products,
                        facets: facets,
                        breadcrumbs: breadcrumbs,
                        path: path,
                        total: total,
                        currentPage: currentPage,
                        itemsPerPage: itemsPerPage,
                        sort: queryWithoutSlug.sort,
                        userAgent: userAgent
                    }));
                case 43:
                    _ctx.prev = 43;
                    _ctx.t9 = _ctx["catch"](9);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_7__/* .log */ .cM)("Cannot get initial props in category page, redirecting", _ctx.t9);
                    res === null || res === void 0 ? void 0 : res.writeHead(302, {
                        Location: "/"
                    });
                    res === null || res === void 0 ? void 0 : res.end();
                case 48:
                    _ctx.t10 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
                    _ctx.next = 51;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57927))
                        ];
                    });
                case 51:
                    _ctx.t11 = _ctx.sent;
                    ref3 = (0, _ctx.t10)(_ctx.t11, 1);
                    SiteWideInitialPropsFailure = ref3[0].SiteWideInitialPropsFailure;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        legacyId: legacyId,
                        slug: slug,
                        total: 0,
                        content: null,
                        query: legalQuery,
                        path: path,
                        currentPage: currentPage,
                        category: null,
                        products: [],
                        facets: [],
                        breadcrumbs: [],
                        itemsPerPage: _data_constants__WEBPACK_IMPORTED_MODULE_4__.PLP_Items_Per_Page
                    }, SiteWideInitialPropsFailure), {
                        sort: queryWithoutSlug.sort,
                        userAgent: userAgent
                    }));
                case 55:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                9,
                43
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}(), BrandPage.getInitialProps = _tmp, _tmp;
/* harmony default export */ __webpack_exports__["default"] = (BrandPage);


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9080,7927,9774,2888,179], function() { return __webpack_exec__(93445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);